var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-auth"},[_c('div',{staticClass:"row box-content",class:{ 'auth-main' : _vm.metaRoute.mainPage === true }},[_c('div',{staticClass:"col-lg-12 col-sm-12 box-form"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }